import * as React from "react";
const AnalyticsIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.94691 12.7379H11.6195V20.9998H7.94691V12.7379ZM17.7153 5.95464V7.00414C17.7153 7.47856 18.0994 7.86267 18.5738 7.86267C19.0482 7.86267 19.4324 7.47856 19.4324 7.00414V3.85853C19.4324 3.38412 19.0482 3 18.5738 3H15.3253C14.8508 3 14.4667 3.38412 14.4667 3.85853C14.4667 4.33295 14.8508 4.71707 15.3253 4.71707H16.531L13.1566 8.15427L9.48989 6.86349C9.16794 6.751 8.82378 6.84277 8.59877 7.06998L3.24915 12.4536C2.91609 12.7889 2.91683 13.3314 3.25211 13.6645C3.58738 13.9983 4.12917 13.9968 4.46297 13.6608L9.4344 8.65833L13.0795 9.9417C13.3881 10.0594 13.7501 9.99277 13.9965 9.7426L17.715 5.95545L17.7153 5.95464ZM3.25665 16.6376H6.92924V20.9998H3.25665V16.6376ZM21 10.2126V21H17.3274V10.2126H21ZM12.6372 14.888H16.3097V21H12.6372V14.888Z"
      fill="#696593"
    />
  </svg>
);
export default AnalyticsIcon;
